import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'

const state =  {
    vehicleTypes: [],
    products: [],
    searchProductDet: [],
    activeCarType: 'Car',
    activeWidth: null,
    activeHeight: null,
    activeDiameter: null,
    activeSpeedIndex: null,
    activeLoadIndex: null,
    activeTyreSeason: null,
    activeBrand: null,
    activeLicencePlate: null,
    widths: [], 
    heights: [], 
    diameters: [], 
    speedIndexes: [],
    loadIndexes: [],
    tyreSeasons: [],
    allSpeedIndexes: [],
    allLoadIndexes: [],
    allTyreSeasons: [], 
    brands: [],
    models: [],
    priceRanges: [],
    categories: [],
    fuelEfficiencies: [],
    wetGrips: [],
    noiseClasses: [],
    noiseValues: [],
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    isShow: false,
    loading: false,
    selectedPriceRange: [],
    filSpeedIndexes: [],
    filLoadIndexes: [],
    filBrands: [],
    filModels: [],
    filPriceRanges: [],
    filCategories: [],
    filFuelEfficiencies: [],
    filWetGrips: [],
    filNoiseClasses: [],
    filNoiseValues: [],
    filTyreSeasons: [],
    vts : null,
    searchStatus: false
}

const getters = {
    vehicleTypes: (state) => state.vehicleTypes,
    products: (state) => state.products,
    searchProductDet: (state) => state.searchProductDet,
    activeVehicleTypes: (state) => state.activeCarType,
    activeWidth: (state) => state.activeWidth,
    activeHeight: (state) => state.activeHeight,
    activeDiameter: (state) => state.activeDiameter,
    activeSpeedIndex: (state) => state.activeSpeedIndex,
    activeLoadIndex: (state) => state.activeLoadIndex,
    activeTyreSeason: (state) => state.activeTyreSeason,
    activeBrand: (state) => state.activeBrand,
    activeLicencePlate: (state) => state.activeLicencePlate,
    widths: state => state.widths,
    heights: state => state.heights,
    diameters: state => state.diameters,
    speedIndexes: state => state.speedIndexes,
    loadIndexes: state => state.loadIndexes,
    tyreSeasons: state => state.tyreSeasons,
    allSpeedIndexes: state => state.allSpeedIndexes,
    allLoadIndexes: state => state.allLoadIndexes,
    allTyreSeasons: state => state.allTyreSeasons,
    brands: state => state.brands,
    models: state => state.models,
    priceRanges: state => state.priceRanges,
    selectedPriceRange: state => state.selectedPriceRange,
    categories: state => state.categories,
    fuelEfficiencies: state => state.fuelEfficiencies,
    wetGrips: state => state.wetGrips,
    noiseClasses: state => state.noiseClasses,
    noiseValues: state => state.noiseValues,
    loading: state => state.loading,
    isShow: (state) => state.isShow,
    response: (state) => state.response,
    filSpeedIndexes: (state) => state.filSpeedIndexes,
    filLoadIndexes: (state) => state.filLoadIndexes,
    filBrands: (state) => state.filBrands,
    filModels: (state) => state.filModels,
    filPriceRanges: (state) => state.filPriceRanges,
    filCategories: (state) => state.filCategories,
    filFuelEfficiencies: (state) => state.filFuelEfficiencies,
    filWetGrips: (state) => state.filWetGrips,
    filNoiseClasses: (state) => state.filNoiseClasses,
    filNoiseValues: (state) => state.filNoiseValues,
    filTyreSeasons: (state) => state.filTyreSeasons,
    vts:(state) => state.vts,
    searchStatus: (state) => state.searchStatus
}

const actions = {
    showError({ commit }, value) {
        commit('setError', value)
    },
    resetError({ commit }) {
        commit('resetState')
    },
    async getVTS({commit}, vehicle_type_slug) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);
            ApiService.get(`/tyre_category/${vehicle_type_slug}`)
                .then(response => {
                    commit('setVTS', response.data);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        })
    },
    async fetchVehicleTypes({ commit }, QueryString) {
        var QS = QueryString || {};
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            ApiService.get('/filter/vehicle-types', {params: QS})
            .then(response => {
                commit('setVehicleTypes', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async getFilters({ commit }) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            const filters = {
                include : JSON.stringify([
                    "tyre-seasons", "speed-indexes",
                    "load-indexes", "fuel-efficiency",
                    "wet-grips", "noise-classes",
                    "noise-values", "price-range",
                    "brands", "models", "categories"
                ])
            };
            ApiService.get('/filter/all', {params : filters})
            .then(response => {

                // commit('setResponse', response.data)
                // commit('setVehicleTypes', response.data.VehicleTypes);
                commit('setTyreSeasons', response.data.TyreSeasons);
                // commit('setWidths', response.data.Widths)
                // commit('setHeights', response.data.Heights)
                // commit('setDiameters', response.data.Diameters)
                commit('setSpeedIndexes', response.data.SpeedIndexes);
                commit('setLoadIndexes', response.data.LoadIndexes);
                commit('setBrands', response.data.Brands);
                commit('setModels', response.data.Models);
                commit('setPriceRanges', response.data.PriceRange);
                commit('setSelectedPriceRange', response.data.PriceRange);
                commit('setCategories', response.data.Categories);
                commit('setFuelEfficiencies', response.data.FuelEfficiency);
                commit('setWetGrips', response.data.WetGrips);
                commit('setNoiseClasses', response.data.NoiseClasses);
                commit('setNoiseValues', response.data.NoiseValues);

                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async getAvailableFilters({ commit }, value) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            /*// Speed index start
            var searchArrFilSpeedIndex = new Object();
            if(value.vehicle_type) {
                searchArrFilSpeedIndex.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilSpeedIndex.width = value.width;
            }
            if(value.height) {
                searchArrFilSpeedIndex.height = value.height;
            }
            if(value.diameter) {
                searchArrFilSpeedIndex.diameter = value.diameter;
            }
            var srtingFilterSpeedIndex = "?include_out_of_stock=true&"+Object.keys(searchArrFilSpeedIndex).map(key => key + '=' + searchArrFilSpeedIndex[key]).join('&');

            ApiService.get('/filter/speed-indexes'+srtingFilterSpeedIndex)
            .then(response => {
                commit('setFilSpeedIndexes', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // Speed index end

            // tyre-seasons start
            var searchArrFilSeason = new Object();
            if(value.vehicle_type) {
                searchArrFilSeason.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilSeason.width = value.width;
            }
            if(value.height) {
                searchArrFilSeason.height = value.height;
            }
            if(value.diameter) {
                searchArrFilSeason.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilSeason.speed_index = value.speed_index;
            }

            var srtingFilterFilSeason = "?include_out_of_stock=true&"+Object.keys(searchArrFilSeason).map(key => key + '=' + searchArrFilSeason[key]).join('&');

            ApiService.get('/filter/tyre-seasons'+srtingFilterFilSeason)
            .then(response => {
                commit('setFilTyreSeasons', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // tyre-seasons end

            // brands start
            var searchArrFilBrand = new Object();
            if(value.vehicle_type) {
                searchArrFilBrand.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilBrand.width = value.width;
            }
            if(value.height) {
                searchArrFilBrand.height = value.height;
            }
            if(value.diameter) {
                searchArrFilBrand.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilBrand.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilBrand.TyreSeasons = value.TyreSeasons;
            }

            var srtingFilterFilBrand = "?include_out_of_stock=true&"+Object.keys(searchArrFilBrand).map(key => key + '=' + searchArrFilBrand[key]).join('&');

            ApiService.get('/filter/brands'+srtingFilterFilBrand)
            .then(response => {
                commit('setFilBrands', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // brands end

            // fuelEfficiency start
            var searchArrFilFuelEfficiency = new Object();
            if(value.vehicle_type) {
                searchArrFilFuelEfficiency.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilFuelEfficiency.width = value.width;
            }
            if(value.height) {
                searchArrFilFuelEfficiency.height = value.height;
            }
            if(value.diameter) {
                searchArrFilFuelEfficiency.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilFuelEfficiency.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilFuelEfficiency.TyreSeasons = value.TyreSeasons;
            }

            if(value.brand_id) {
                searchArrFilFuelEfficiency.brand_id = value.brand_id;
            }

            var srtingFilterFilFuelEfficiency = "?include_out_of_stock=true&"+Object.keys(searchArrFilFuelEfficiency).map(key => key + '=' + searchArrFilFuelEfficiency[key]).join('&');

            ApiService.get('/filter/fuel-efficiency'+srtingFilterFilFuelEfficiency)
            .then(response => {
                commit('setFilFuelEfficiencies', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // fuelEfficiency end

            // wetgrip start
            var searchArrFilWetGrip = new Object();
            if(value.vehicle_type) {
                searchArrFilWetGrip.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilWetGrip.width = value.width;
            }
            if(value.height) {
                searchArrFilWetGrip.height = value.height;
            }
            if(value.diameter) {
                searchArrFilWetGrip.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilWetGrip.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilWetGrip.TyreSeasons = value.TyreSeasons;
            }

            if(value.brand_id) {
                searchArrFilWetGrip.brand_id = value.brand_id;
            }

            if(value.fuel_efficiency) {
                searchArrFilWetGrip.fuel_efficiency = value.fuel_efficiency;
            }
            
            var srtingFilterFilWetGrip = "?include_out_of_stock=true&"+Object.keys(searchArrFilWetGrip).map(key => key + '=' + searchArrFilWetGrip[key]).join('&');

            ApiService.get('/filter/wet-grips'+srtingFilterFilWetGrip)
            .then(response => {
                commit('setFilWetGrips', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // wetgrip start

            //noice class start
            var searchArrFilNoiceClass = new Object();
            if(value.vehicle_type) {
                searchArrFilNoiceClass.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilNoiceClass.width = value.width;
            }
            if(value.height) {
                searchArrFilNoiceClass.height = value.height;
            }
            if(value.diameter) {
                searchArrFilNoiceClass.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilNoiceClass.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilNoiceClass.TyreSeasons = value.TyreSeasons;
            }

            if(value.brand_id) {
                searchArrFilNoiceClass.brand_id = value.brand_id;
            }

            if(value.fuel_efficiency) {
                searchArrFilNoiceClass.fuel_efficiency = value.fuel_efficiency;
            }

            if(value.wet_grip) {
                searchArrFilNoiceClass.wet_grip = value.wet_grip;
            }

            var srtingFilterFilNoiceClass = "?include_out_of_stock=true&"+Object.keys(searchArrFilNoiceClass).map(key => key + '=' + searchArrFilNoiceClass[key]).join('&');

            ApiService.get('/filter/noise-classes'+srtingFilterFilNoiceClass)
            .then(response => {
                commit('setFilNoiseClasses', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            //noice class end
            
            //noice value start
            var searchArrFilNoiceValue = new Object();
            if(value.vehicle_type) {
                searchArrFilNoiceValue.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilNoiceValue.width = value.width;
            }
            if(value.height) {
                searchArrFilNoiceValue.height = value.height;
            }
            if(value.diameter) {
                searchArrFilNoiceValue.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilNoiceValue.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilNoiceValue.TyreSeasons = value.TyreSeasons;
            }

            if(value.brand_id) {
                searchArrFilNoiceValue.brand_id = value.brand_id;
            }

            if(value.fuel_efficiency) {
                searchArrFilNoiceValue.fuel_efficiency = value.fuel_efficiency;
            }

            if(value.wet_grip) {
                searchArrFilNoiceValue.wet_grip = value.wet_grip;
            }

            if(value.noise_class) {
                searchArrFilNoiceValue.noise_class = value.noise_class;
            }

            var srtingFilterFilNoiceValue = "?include_out_of_stock=true&"+Object.keys(searchArrFilNoiceValue).map(key => key + '=' + searchArrFilNoiceValue[key]).join('&');

            ApiService.get('/filter/noise-values'+srtingFilterFilNoiceValue)
            .then(response => {
                commit('setFilNoiseValues', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            //noice value end

            //load index start
            var searchArrFilLoadIndex = new Object();
            if(value.vehicle_type) {
                searchArrFilLoadIndex.vehicle_type = value.vehicle_type;
            }
            if(value.width) {
                searchArrFilLoadIndex.width = value.width;
            }
            if(value.height) {
                searchArrFilLoadIndex.height = value.height;
            }
            if(value.diameter) {
                searchArrFilLoadIndex.diameter = value.diameter;
            }

            if(value.speed_index) {
                searchArrFilLoadIndex.speed_index = value.speed_index;
            }

            if(value.TyreSeasons) {
                searchArrFilLoadIndex.TyreSeasons = value.TyreSeasons;
            }

            if(value.brand_id) {
                searchArrFilLoadIndex.brand_id = value.brand_id;
            }

            if(value.fuel_efficiency) {
                searchArrFilLoadIndex.fuel_efficiency = value.fuel_efficiency;
            }

            if(value.wet_grip) {
                searchArrFilLoadIndex.wet_grip = value.wet_grip;
            }

            if(value.noise_class) {
                searchArrFilLoadIndex.noise_class = value.noise_class;
            }

            var srtingFilterFilLoadIndex = "?include_out_of_stock=true&"+Object.keys(searchArrFilLoadIndex).map(key => key + '=' + searchArrFilLoadIndex[key]).join('&');

            ApiService.get('/filter/load-indexes'+srtingFilterFilLoadIndex)
            .then(response => {
                commit('setFilLoadIndexes', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
            // load index end*/

            var srtingFilter = "?include=" + JSON.stringify([
                "tyre-seasons","diameters",
                "speed-indexes","load-indexes",
                "fuel-efficiency","wet-grips",
                "noise-classes","noise-values",
                "price-range","brands",
                "models","categories"]);

            if(value != "" && value != "undefined") {
                //srtingFilter = "?include_out_of_stock=true&"+value;
                srtingFilter += "&"+value;
            }

            ApiService.get('/filter/all'+srtingFilter)
            .then(response => {

                // commit('setResponse', response.data)
                // commit('setVehicleTypes', response.data.VehicleTypes);
                // commit('setTyreSeasons', response.data.TyreSeasons);
                //commit('setWidths', response.data.Widths)
                // commit('setHeights', response.data.Heights)
                // commit('setDiameters', response.data.Diameters)

                commit('setFilSpeedIndexes', response.data.SpeedIndexes);
                commit('setFilLoadIndexes', response.data.LoadIndexes);
                commit('setFilBrands', response.data.Brands);
                commit('setFilModels', response.data.Models);
                commit('setFilPriceRanges', response.data.PriceRange);
                commit('setFilCategories', response.data.Categories);
                commit('setFilFuelEfficiencies', response.data.FuelEfficiency);
                commit('setFilWetGrips', response.data.WetGrips);
                commit('setFilNoiseClasses', response.data.NoiseClasses);
                commit('setFilNoiseValues', response.data.NoiseValues);
                commit('setFilTyreSeasons', response.data.TyreSeasons);
                /*commit('setSpeedIndexes', response.data.SpeedIndexes);
                commit('setLoadIndexes', response.data.LoadIndexes);
                commit('setBrands', response.data.Brands);
                commit('setPriceRanges', response.data.PriceRange);
                commit('setCategories', response.data.Categories);
                commit('setFuelEfficiencies', response.data.FuelEfficiency);
                commit('setWetGrips', response.data.WetGrips);
                commit('setNoiseClasses', response.data.NoiseClasses);
                commit('setNoiseValues', response.data.NoiseValues);*/

                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchWidths({ commit }, filters){

        var filStr = "";

        if((filters.DynamicFilters && filters.DynamicFilters != "")) {
            filStr = filters.DynamicFilters;
        } 

        return await new Promise((resolve, reject) => {
            commit('setLoading', true)

            commit('setHeights', []);
            commit('setDiameters', []);

            ApiService.get('/filter/widths?vehicle_type=["'+state.activeCarType+'"]'+filStr)
            .then(response => {
                commit('setWidths', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchHeights({ commit }, filters){

        var filStr = "";

        if(filters.width != null && (filters.DynamicFilters && filters.DynamicFilters != "")) {
            filStr = '?width=['+filters.width+']&'+filters.DynamicFilters;
        } else if(filters.width != null) {
            filStr = '?width=['+filters.width+']&vehicle_type=["'+state.activeCarType+'"]';
        }

        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/heights'+filStr)
            .then(response => {
                commit('setHeights', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchAllSpeedIndexes({ commit }){
        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/speed-indexes')
            .then(response => {
                commit('setAllSpeedIndexes', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchAllTyreSeasons({ commit }){
        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/tyre-seasons')
            .then(response => {
                commit('setAllTyreSeasons', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchAllLoadIndexes({ commit }){
        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/load-indexes')
            .then(response => {
                commit('setAllLoadIndexes', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchAllBrands({ commit }, value) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            ApiService.get('/filter/brands')
            .then(response => {
                commit('setBrands', response.data);
                
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchAllModels({ commit }, value) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            ApiService.get('/filter/models')
            .then(response => {
                commit('setModels', response.data);
                
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async fetchDiameters({ commit }, filters){

        var filStr = "";

        if( (filters.searchBySize && filters.searchBySize.length != 0) && (filters.DynamicFilters && filters.DynamicFilters != "")) {
            filStr = '?height=['+filters.searchBySize.height+']&width=['+filters.searchBySize.width+']&'+filters.DynamicFilters;
        } else if(filters.searchBySize && filters.searchBySize.length != 0) {
            filStr = '?height=['+filters.searchBySize.height+']&width=['+filters.searchBySize.width+']&vehicle_type=["'+state.activeCarType+'"]';
        }

        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/diameters'+filStr)
            .then(response => {
                commit('setDiameters', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    async changeCarTypes({ commit }, selectedCarType) {
        var vehicle_type = '', service_point = null;
        if (typeof selectedCarType === 'object' && selectedCarType !== null) {
            vehicle_type = selectedCarType.vehicle_type;
            service_point= selectedCarType.ServicePoint;
        } else {
            vehicle_type = selectedCarType;
        }
        commit('setChangeCarTypes', vehicle_type);
        var QS = {
            vehicle_type : JSON.stringify([state.activeCarType])
        }
        if (service_point !== null) {
            QS.ServicePoint = service_point;
        }
        QS.include = JSON.stringify(["widths"]);
        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            ApiService.get('/filter/all', { params : QS })
            .then(response => {
                // commit('setResponse', response.data)
                // commit('setTyreSeasons', response.data.TyreSeasons)
                commit('setWidths', response.data.Widths)
                // commit('setHeights', response.data.Heights)
                // commit('setDiameters', response.data.Diameters)
                // commit('setSpeedIndexes', response.data.SpeedIndexes)
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    changeWidthStore({ commit }, selectedWidth) {
        commit('setChangeWidth', selectedWidth);
    },
    changeHeightStore({ commit }, selectedHeight) {
        commit('setChangeHeight', selectedHeight);
    },
    changeDiameterStore({ commit }, selectedDiameter) {
        commit('setChangeDiameter', selectedDiameter);
    },
    changeSpeedIndexStore({ commit }, selectedSpeedIndex) {
        commit('setChangeSpeedIndex', selectedSpeedIndex);
    },
    changeLoadIndexStore({ commit }, selectedLoadIndex) {
        commit('setChangeLoadIndex', selectedLoadIndex);
    },
    changeTyreSeasonStore({ commit }, selectedTyreSeason) {
        commit('setChangeTyreSeason', selectedTyreSeason);
    },
    changeBrandStore({ commit }, selectedBrand) {
        commit('setChangeBrand', selectedBrand);
    },
    changeLicencePlateStore({ commit }, selectedLicencePlate) {
        commit('setChangeLicencePlate', selectedLicencePlate);
    },
    async filterProducts({ commit }, searchStr) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setIsShow', true)
            // ApiService.get('/products?'+searchStr)
            // ApiService.get('/products?per_page=10')
            ApiService.get('/products'+searchStr)
            .then(response => {
                commit('setProducts', response.data.data)
                commit('setSearchProductDet', response.data)
                
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    setSelectedPrice({commit}, priceRange) {
        commit('setSelectedPriceRange', priceRange)
    },
    setTyreSeasons({commit}, data) {
        commit('setTyreSeasons', data)
    },
    setBrandsList({commit}, data) {
        commit('setBrands', data)
    },
    setModelsList({commit}, data) {
        commit('setModels', data)
    },
    async storeBrands({commit}, filters) {

        return await new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            var filStr = "";

            if(filters.searchBySize && filters.searchBySize.length != 0) {
                filStr = '?height=['+filters.searchBySize.height+']&width=['+filters.searchBySize.width+']&vehicle_type=["'+state.activeCarType+'"]&diameter=["'+filters.searchBySize.diameter+'"]';
            }

            var tyreSeasons = [];

            if(localStorage.getItem("tyreSeasonsLists")){
                this.tyreSeasons = HashMake.decrypt(localStorage.getItem("tyreSeasonsLists"));
            }

            if(state.activeTyreSeason != "All") {

                if(state.activeTyreSeason != undefined) {
                    
                    var tyreSeasonsList = this.tyreSeasons;
                    var selectedTyreSeasonsId = [];
                    if (tyreSeasonsList)
                    {
                        var tyreSeasonId = tyreSeasonsList.find(tyreSeason => tyreSeason.name === state.activeTyreSeason).id;
                        selectedTyreSeasonsId.push(tyreSeasonId);

                        // searchArr.tyre_season_id = '['+selectedTyreSeasonsId+']';
                        filStr += '&tyre_season_id=['+selectedTyreSeasonsId+']';
                    }
                }
            }

            ApiService.get('/filter/brands'+filStr)
            .then(response => {
                commit('setBrands', response.data);
                localStorage.setItem("brandLists", HashMake.encrypt(response.data));
                resolve();
            })
            .catch(error => {

                commit('setResponse', error.response)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    storeModels({commit}) {

        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true);

            ApiService.get('/filter/models')
            .then(response => {
                commit('setModels', response.data);
                localStorage.setItem("modelLists", HashMake.encrypt(response.data));
                resolve();
            })
            .catch(error => {

                commit('setResponse', error.response)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    storeTyreSeasons({commit}, data) {
        

        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.get('filter/tyre-seasons')
            .then(response => {
                commit('setAllTyreSeasons', response.data);
                localStorage.setItem("tyreSeasonsLists", HashMake.encrypt(response.data))
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
        
    },
    setSearchStatus({commit}, status) {
        commit('setSearchStatus', status);
    },
    setFilPriceRanges({commit}, priceRange) {
        commit('setFilPriceRanges', priceRange);
    }
}

const mutations = {
    setSelectedPriceRange(state, data) {
        state.selectedPriceRange = [data.min_price, data.max_price]
    },
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setVTS(state, vts) {
        state.vts = vts
    },
    setVehicleTypes(state, vehicleTypesList) {
        state.vehicleTypes = vehicleTypesList;
    },
    setChangeCarTypes(state, seletedCartype) {
        state.activeCarType = seletedCartype;
    },
    setChangeWidth(state, seletedWidth) {
        state.activeWidth = seletedWidth;
    },
    setChangeHeight(state, seletedHeight) {
        state.activeHeight = seletedHeight;
    },
    setChangeDiameter(state, seletedDiameter) {
        state.activeDiameter = seletedDiameter;
    },
    setChangeSpeedIndex(state, seletedSpeedIndex) {
        state.activeSpeedIndex = seletedSpeedIndex;
    },
    setChangeLoadIndex(state, seletedLoadIndex) {
        state.activeLoadIndex = seletedLoadIndex;
    },
    setChangeTyreSeason(state, seletedTyreSeason) {
        state.activeTyreSeason = seletedTyreSeason;
    },
    setChangeBrand(state, seletedBrand) {
        state.activeBrand = seletedBrand;
    },
    setChangeLicencePlate(state, seletedLicencePlate) {
        state.activeLicencePlate = seletedLicencePlate;
    },
    setWidths(state, widthsList) {
        state.widths = widthsList;
    },
    setHeights(state, heightsList) {
        state.heights = heightsList;
    },
    setDiameters(state, diametersList) {
        state.diameters = diametersList;
    },
    setSpeedIndexes(state, speedIndexesList) {
        state.speedIndexes = speedIndexesList;
    },
    setLoadIndexes(state, loadIndexesList) {
        state.loadIndexes = loadIndexesList;
    },
    setTyreSeasons(state, tyreSeasonsList) {
        state.tyreSeasons = tyreSeasonsList;
    },
    setAllSpeedIndexes(state, allSpeedIndexesList) {
        state.allSpeedIndexes = allSpeedIndexesList;
    },
    setAllLoadIndexes(state, allLoadIndexesList) {
        state.allLoadIndexes = allLoadIndexesList;
    },
    setAllTyreSeasons(state, allTyreSeasonsList) {
        state.allTyreSeasons = allTyreSeasonsList;
        // state.tyreSeasons = allTyreSeasonsList;
    },
    setBrands(state, brandsList) {
        state.brands = brandsList;
    },
    setModels(state, modelsList) {
        state.models = modelsList;
    },
    setPriceRanges(state, priceRangesList) {
        state.priceRanges = priceRangesList;
    },
    setCategories(state, categoriesList) {
        state.categories = categoriesList;
    },
    setFuelEfficiencies(state, fuelEfficienciesList) {
        state.fuelEfficiencies = fuelEfficienciesList;
    },
    setWetGrips(state, wetGripsList) {
        state.wetGrips = wetGripsList;
    },
    setNoiseClasses(state, noiseClassesList) {
        state.noiseClasses = noiseClassesList;
    },
    setNoiseValues(state, noiseValuesList) {
        state.noiseValues = noiseValuesList;
    },
    setProducts(state, productsList) {
        state.products = productsList;
    },
    setSearchProductDet(state, productSearchDet) {
        state.searchProductDet = productSearchDet;
    },
    setResponse(state, data) {
        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },
    setError(state, data) {
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data.errors;
    },
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];
    },
    setFilSpeedIndexes(state, filSpeedIndexesList) {
        state.filSpeedIndexes = filSpeedIndexesList;
    },
    setFilLoadIndexes(state, filLoadIndexesList) {
        state.filLoadIndexes = filLoadIndexesList;
    },
    setFilBrands(state, filBrandsList) {
        state.filBrands = filBrandsList;
    },
    setFilModels(state, filModelsList) {
        state.filModels = filModelsList;
    },
    setFilPriceRanges(state, filPriceRangesList) {
        state.filPriceRanges = filPriceRangesList;
    },
    setFilCategories(state, filCategoriesList) {
        state.filCategories = filCategoriesList;
    },
    setFilFuelEfficiencies(state, filFuelEfficienciesList) {
        state.filFuelEfficiencies = filFuelEfficienciesList;
    },
    setFilWetGrips(state, filWetGripsList) {
        state.filWetGrips = filWetGripsList;
    },
    setFilNoiseClasses(state, filNoiseClassesList) {
        state.filNoiseClasses = filNoiseClassesList;
    },
    setFilNoiseValues(state, filNoiseValuesList) {
        state.filNoiseValues = filNoiseValuesList;
    },
    setFilTyreSeasons(state, filTyreSeasonsList) {
        state.filTyreSeasons = filTyreSeasonsList;
    },
    setSearchStatus(state, searchStatus) {
        state.searchStatus = searchStatus;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}